import HelpCenterComponent from "../../../components/partner/help-center/help-center";

export default function HelpCenter() {
    return <HelpCenterComponent />;
  }